import { render, staticRenderFns } from "./settlementEdit.vue?vue&type=template&id=3480585c&scoped=true&"
import script from "./settlementEdit.vue?vue&type=script&lang=js&"
export * from "./settlementEdit.vue?vue&type=script&lang=js&"
import style0 from "./settlementEdit.vue?vue&type=style&index=0&id=3480585c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480585c",
  null
  
)

export default component.exports